import { RemoteGlobalSettingsService } from '@prodcard/core-web-app'
import { httpClient } from './remote'

const globalSettingsService = new RemoteGlobalSettingsService(httpClient)

export { globalSettingsService }
